import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import withFeature from '../FeatureFlag/WithFeature';
import SoftwareUpdates from './SoftwareUpdates';
import { useIsCloudOnly } from '../SystemSettings/hooks/featureFlags/useIsCloudOnly';

const SoftwareUpdatesWithFeature = (props) => {
    const isCloudOnly = useIsCloudOnly();

    return withFeature({
        featureKey: FEATURE_FLAGS_NAMES.SystemMode,
        featureName: 'systemMode',
        predicate: (systemMode) => systemMode !== undefined
    })(SoftwareUpdates)({ ...props, isCloudOnly });
};

export default SoftwareUpdatesWithFeature;
